import React from "react";

const KPICard = ({
  title,
  value,
  unit,
  icon: Icon,
  subText,
  // --- Các props cũ (giữ lại để tương thích) ---
  highlight,
  warning,
  // --- Các props mới để Custom màu ---
  iconClassName, // Class cho icon và nền icon (VD: "bg-blue-100 text-blue-600")
  valueClassName, // Class cho màu chữ số liệu (VD: "text-blue-700")
  cardClassName, // Class cho viền hoặc nền card (VD: "ring-1 ring-blue-100 bg-blue-50")
}) => {
  // 1. Xử lý logic màu Icon
  // Ưu tiên: iconClassName truyền vào > warning > highlight > mặc định
  const defaultIconClass = warning
    ? "bg-red-100 text-red-600"
    : highlight
    ? "bg-purple-100 text-purple-600"
    : "bg-slate-100 text-slate-500";
  
  const finalIconClass = iconClassName || defaultIconClass;

  // 2. Xử lý logic màu Value (Số liệu)
  const defaultValueClass = warning ? "text-red-600" : "text-slate-900";
  const finalValueClass = valueClassName || defaultValueClass;

  // 3. Xử lý logic style Card (Container)
  const defaultCardClass = highlight ? "ring-1 ring-purple-100 bg-purple-50/30" : "";
  const finalCardClass = cardClassName || defaultCardClass;

  return (
    <div
      className={`bg-white rounded-xl p-4 border border-slate-100 shadow-sm hover:shadow-md transition-all ${finalCardClass}`}
    >
      <div className="flex justify-between items-start mb-2">
        <p className="text-sm font-medium text-slate-500">{title}</p>
        <div className={`p-1.5 rounded-lg ${finalIconClass}`}>
          <Icon size={16} />
        </div>
      </div>
      
      <div className="flex items-baseline gap-1 mt-1">
        <h3 className={`text-2xl font-bold ${finalValueClass}`}>{value}</h3>
        {unit && <span className="text-sm text-slate-500 font-medium">{unit}</span>}
      </div>

      <div className="flex items-center gap-2 mt-3 h-5">
        <span className="text-xs text-slate-400">{subText || "Cập nhật hôm nay"}</span>
      </div>
    </div>
  );
};

export default KPICard;